/*
 * A health check to ping the identity provider for its health.
 * The exposed `/api` route pings the `.provider_server_is_online()` method of the chosen
 * identity provider in the back end service.
 * The response will be logged in the browser.
 */
export async function authenticationHealthCheck(): Promise<string> {
  const url = '/api/authentication/health_check';

  return await fetch(url)
    .then((success) => {
      return `Response of pinging identity provider : ${success.statusText} - ${success.status}`;
    })
    .catch((error) => {
      throw error;
    });
}
